import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { FAQComponent } from './faq.component';
import { SupportAndLearnComponent } from './support-and-learn/support-and-learn.component';

const routes: Routes = [
  { path: 'faq',  component: SupportAndLearnComponent },
  { path: 'faq/privacy-policy', component: SupportAndLearnComponent},
  { path: 'faq/terms-of-service', component: SupportAndLearnComponent},
  { path: 'faq/contact-us', component: SupportAndLearnComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FAQRoutingModule { }
